<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 py-3">
        <div class="mb-4 flex">
            <BaseInputCheckbox
                v-model="formValues.no_answer"
                :label="$t('ecsp.natural.experience.no_answer')"
                name="experience.no_answer" />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.financial_education"
                :required="isRequiredNaturalComplianceProfileAttribute('experience', 'financial_education')"
                name="experience.financial_education"
                :options="
                    enumToSelectOptions(App.Enums.ComplianceProfile.ECSP.FinancialEducation, 'ecsp.financial_education')
                "
                :label="$t('ecsp.natural.experience.financial_education')"
                :disabled="disabled"
                vertical />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.bonds_knowledge"
                :required="isRequiredNaturalComplianceProfileAttribute('experience', 'bonds_knowledge')"
                name="experience.bonds_knowledge"
                :options="yesNoDenyOptions"
                :label="$t('ecsp.natural.experience.bonds_knowledge')"
                :disabled="disabled"
                vertical />
        </div>
        <div
            v-if="formValues.bonds_knowledge === App.Enums.ComplianceProfile.ECSP.YesNoDenyOption.YES"
            class="flex pl-10">
            <BaseInputRadio
                v-model="formValues.bonds_investment_frequency"
                required
                name="experience.bonds_investment_frequency"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.InvestmentFrequencyOption,
                        'ecsp.investment_frequency'
                    )
                "
                :label="$t('ecsp.natural.experience.bonds_investment_frequency')"
                :disabled="disabled"
                vertical />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.stocks_knowledge"
                :required="isRequiredNaturalComplianceProfileAttribute('experience', 'stocks_knowledge')"
                name="experience.stocks_knowledge"
                :options="yesNoDenyOptions"
                :label="$t('ecsp.natural.experience.stocks_knowledge')"
                :disabled="disabled"
                vertical />
        </div>
        <div
            v-if="formValues.stocks_knowledge === App.Enums.ComplianceProfile.ECSP.YesNoDenyOption.YES"
            class="flex pl-10">
            <BaseInputRadio
                v-model="formValues.stocks_investment_frequency"
                required
                name="experience.stocks_investment_frequency"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.InvestmentFrequencyOption,
                        'ecsp.investment_frequency'
                    )
                "
                :label="$t('ecsp.natural.experience.stocks_investment_frequency')"
                :disabled="disabled"
                vertical />
        </div>
        <div class="flex">
            <BaseInputRadio
                v-model="formValues.convertible_bonds_knowledge"
                required
                name="experience.convertible_bonds_knowledge"
                :options="yesNoDenyOptions"
                :label="$t('ecsp.natural.experience.convertible_bonds_knowledge')"
                :disabled="disabled"
                vertical />
        </div>
        <div
            v-if="formValues.convertible_bonds_knowledge === App.Enums.ComplianceProfile.ECSP.YesNoDenyOption.YES"
            class="flex pl-10">
            <BaseInputRadio
                v-model="formValues.convertible_bonds_investment_frequency"
                required
                name="experience.convertible_bonds_investment_frequency"
                :options="
                    enumToSelectOptions(
                        App.Enums.ComplianceProfile.ECSP.InvestmentFrequencyOption,
                        'ecsp.investment_frequency'
                    )
                "
                :label="$t('ecsp.natural.experience.convertible_bonds_investment_frequency')"
                :disabled="disabled"
                vertical />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ecspPersonalComplianceProfileConfig } from '../../../account/personal/complianceProfile/ecspComplianceProfile'
import {
    clearFormValuesNoAnswer,
    getNaturalWidgetFormValidationRules,
    initializeNaturalWidgetForm,
    isRequiredNaturalComplianceProfileAttribute,
} from '../../ESAC/form/forms'
import { yesNoDenyOptions } from '../../../../data'
import BaseInputRadio from '../../../base/BaseInputRadio.vue'
import { enumToSelectOptions } from '../../../../utilities/helpers'
import { App } from '../../../../typings/api-enums'
import BaseInputCheckbox from '../../../base/BaseInputCheckbox.vue'
import { computed, watch } from 'vue'
import { useVModel } from '@vueuse/core'

const props = defineProps<{
    modelValue: App.Services.ComplianceProfile.ECSP.Categories.Natural.EcspExperienceDto
}>()
const emit = defineEmits(['update:modelValue'])
const formValues = useVModel(props, 'modelValue', emit)

const disabled = computed(() => {
    return formValues.value.no_answer === true
})

watch(
    () => formValues.value,
    () => {
        clearFormValuesNoAnswer(formValues)
        if (formValues.value.bonds_knowledge !== App.Enums.ComplianceProfile.ECSP.YesNoDenyOption.YES) {
            formValues.value.bonds_investment_frequency = null
        }
        if (formValues.value.stocks_knowledge !== App.Enums.ComplianceProfile.ECSP.YesNoDenyOption.YES) {
            formValues.value.stocks_investment_frequency = null
        }
        if (formValues.value.convertible_bonds_knowledge !== App.Enums.ComplianceProfile.ECSP.YesNoDenyOption.YES) {
            formValues.value.convertible_bonds_investment_frequency = null
        }
    },
    { deep: true }
)

initializeNaturalWidgetForm(
    getNaturalWidgetFormValidationRules(
        ecspPersonalComplianceProfileConfig['Experience'].validationKey,
        'ecsp',
        ecspPersonalComplianceProfileConfig['Experience'].denyKey
    ),
    null,
    'ecsp'
)
</script>
